import './page/tdcp-customer-price-list';
import './page/tdcp-customer-price-detail';

Shopware.Module.register('tdcp-customer-prices', {
    type: 'plugin',
    name: 'tdcp-customer-prices.module.name',
    title: 'tdcp-customer-prices.module.title',
    description: 'tdcp-customer-prices.module.description',
    color: '#189eff',
    icon: 'regular-currency-euro',

    routes: {
        list: {
            component: 'tdcp-customer-price-list',
            path: 'list',
        },
        detail: {
            component: 'tdcp-customer-price-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'tdcp.customer.prices.list',
            },
        },
    },

    navigation: [{
        id: 'tdcp-customer-prices',
        label: 'tdcp-customer-prices.module.title',
        color: '#189eff',
        icon: 'regular-currency-euro',
        path: 'tdcp.customer.prices.list',
        position: 100,
        parent: 'sw-catalogue',
    }],
});
